export default {
    state: {
        list: null,

        count: null,

        devicesTypes: null,

        filters: {
            search: "",
            users: []
        },

        advertisers: null
    },

    mutations: {
        DEVICES_SET_LIST(state, list) {
            state.list = list;
        },

        DEVICES_SET_COUNT(state, count) {
            state.count = count;
        },

        DEVICES_SET_TYPE(state, devicesTypes) {
            state.devicesTypes = devicesTypes;
        },

        DEVICES_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value
            };
        },
        SET_DEVICES_LIST(state, list) {
            state.list = list;
        },

        DEVICES_RESET_FILTERS(state) {
            state.filters = {
                search: "",
                users: []
            };
        }
    }
};
